import { useState, useEffect } from 'react';
import { Card, Spin, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../../hooks/use_api';

const CACHE_KEY = 'vellby:my-relationships';

function MyRelationships() {
    const navigate = useNavigate();
    const api = useApi();
    const [relationships, setRelationships] = useState(() => {
        try {
            const cached = sessionStorage.getItem(CACHE_KEY);
            return cached ? JSON.parse(cached) : [];
        } catch { return []; }
    });
    const [loading, setLoading] = useState(relationships.length === 0);

    useEffect(() => {
        const showSpinner = relationships.length === 0;
        if (showSpinner) setLoading(true);

        api.get('/api/entities', { params: { entity_type: 'relationship' } })
            .then(data => {
                const list = Array.isArray(data) ? data : [];
                setRelationships(list);
                setLoading(false);
                try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(list)); } catch { /* ignore */ }
            })
            .catch(err => {
                console.error('Error fetching relationships:', err);
                setRelationships([]);
                setLoading(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return <Spin />;
    }

    return <div>
        <h2>My Relationships</h2>
        <Space>
            {
                relationships.map(
                    relationship => <Card
                        key={relationship.id}
                        onClick={() => { navigate(`/entity/${relationship.id}`) }}
                        size="small"
                        style={{ width: 300, height: 100, border: '1px solid #ccc', borderRadius: '4px' }}
                        title={<><strong>{relationship.name}</strong>
                            <span style={{ marginLeft: 8, color: '#888', fontSize: '0.85em' }}>
                                [{relationship.entity_type}]
                            </span></>}
                    >
                        {relationship.description && <p>{relationship.description}</p>}
                    </Card>
                )
            }
        </Space>
    </div>;
}

export default MyRelationships;
